module.exports = __webpack_public_path__ + "img/ai-agent-mobile.095d2f98.svg";